var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostponedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0305 13.172L6.9696 7.11105M13.0305 7.11184L6.9696 13.1728M19 10.1426C19 5.17195 14.9706 1.14258 10 1.14258C5.02944 1.14258 1 5.17195 1 10.1426C1 15.1131 5.02944 19.1426 10 19.1426C14.9706 19.1426 19 15.1131 19 10.1426Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostponedIcon);
export default __webpack_public_path__ + "static/media/postponedIcon.c2743614d81fc7d69a3d83a0dd86e992.svg";
export { ForwardRef as ReactComponent };